const template=`
<div class="searchListWidget widgetDetails">
  <div class="widgetContentMax">
    <widget-status></widget-status><span ng-hide="searchIsLoading || !widget.hasRequiredSettings()">
      <widget-content-stream-maximized widget="widget" is-loading="searchIsLoading"></widget-content-stream-maximized></span>
  </div>
</div>`;
export default template;
